import config_club_runupforme from './config-club-runupforme';
import config_club_planetefitness from './config-club-planetefitness';
import config_borne_planetefitness from './config-borne-club-planetefitness';
import config_borne_runupforme from './config-borne-runupforme';
import config_ofc from './config-ofc';
import config_genae from './config-genae';
import config_accrosport from './config-accrosport';
import config_atomfitness from './config-atomfitness';
import config_oriasport from './config-oriasport';
import config_climbarena from './config-climbarena';
import config_energiness from './config-energiness';
import config_wakeupform from './config-wakeupform';
import config_centralfit from './config-centralfit';
import config_lesbruyeres from './config-lesbruyeres';
import config_magicformepone from './config-magicformepone';
import config_onair_integration from './config-onair-integration';
import config_sportavenue from './config-sportavenue';
import config_solliesgym from './config-solliesgym';
import config_irongym from './config-irongym';
import config_fitinparis from './config-fitinparis';
import config_club_easyfit from './config-club-easyfit';
import config_borne_easyfit from './config-borne-easyfit';

export default function getConfig() {
	const host = window.location.host;

	if( host.startsWith('pass.runupforme') ) {
		return config_club_runupforme;
	}

	if( host.startsWith('pass-borne.runupforme') ) {
		return config_borne_runupforme;
	}

	if( host.startsWith('pass.club-planetefitness') ) {
		return config_club_planetefitness;
	}

	if( host.startsWith('pass-borne.club-planetefitness') ) {
		return config_borne_planetefitness;
	}

	if( host.startsWith('pass.easy-fit.') ) {
		return config_club_easyfit;
	}

	if( host.startsWith('pass-borne.easy-fit.') ) {
		return config_borne_easyfit;
	}

	if( host.startsWith('pass.atom-fitnessbeziers') ) {
		return config_atomfitness;
	}

	if ( host.startsWith('pass.onefitnessclub.') || host.startsWith('pass-onefitnessclub-preprod') ) {
		if (host.startsWith('pass-onefitnessclub-preprod')) {
			const config_ofc_preprod = { ...config_ofc, code: "onefitnessclub.preprod", };
			return config_ofc_preprod;
		}
		else {
			return config_ofc;
		}
	}

	if ( host.startsWith('pass.genaeclub.') ) {
		return config_genae;
	}

	if ( host.startsWith('pass.accrosport.') ) {
		return config_accrosport;
	}

	if ( host.startsWith('pass.oria-sport.') ) {
		return config_oriasport;
	}

	if ( host.startsWith('pass.climbarena.') ) {
		return config_climbarena;
	}

	if (host.startsWith('pass.energiness.')) {
		return config_energiness;
	}

	if (host.startsWith('pass.wakeupform.')) {
		return config_wakeupform;
	}

	if (host.startsWith('pass-centralfit.masalledesport.')) {
		return config_centralfit;
	}

	if (host.startsWith('pass.les-bruyeres.')) {
		return config_lesbruyeres;
	}

	if (host.startsWith('pass.magicformepone.')) {
		return config_magicformepone;
	}

	if (host.startsWith('pass.onair-fitness.localhost')) {
		return config_onair_integration;
	}

	if (host.startsWith('pass.sport-avenue-pau.')) {
		return config_sportavenue;
	}

	if (host.startsWith('pass.solliesgym.')) {
		return config_solliesgym;
	}

	if (host.startsWith('pass.iron-gym.')) {
		return config_irongym;
	}

	if (host.startsWith('pass.fitinparis.')) {
		return config_fitinparis;
	}

	throw new Error("No config for host " + host);
}
